import { createReducer } from 'services/reduxHelpers'
import { playgroundTypes } from 'reduxModules/actions/PlaygroundActions'

/* ------------- Initial State ------------- */

export const initialState = {
  bookings: [],
  isComplete: false,
}

/* ------------- Hookup Reducers To Types ------------- */

export default createReducer(initialState, {
  [playgroundTypes.GET_ALL_BOOKINGS_SUCCESS]: ({ bookings }, { data }) => ({
    bookings: [
      ...bookings,
      ...data.bookings
    ],
    isComplete: data.isComplete
  }),
})



// WEBPACK FOOTER //
// ./src/reduxModules/reducers/PlaygroundReducer.js